
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1fx7M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hCb7M")).default; });

var $hCb7M = parcelRequire("hCb7M");

});
parcelRegister("hCb7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e24a006ad056402e$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $3ayMq = parcelRequire("3ayMq");

var $5ohHq = parcelRequire("5ohHq");

var $jnh2H = parcelRequire("jnh2H");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $1rXz0 = parcelRequire("1rXz0");
var $chlmU = parcelRequire("chlmU");
parcelRequire("MciJy");
var $85vSY = parcelRequire("85vSY");
parcelRequire("hqKpV");
var $3ItZP = parcelRequire("3ItZP");

var $bd3Mi = parcelRequire("bd3Mi");

var $bU2dC = parcelRequire("bU2dC");

var $5YjMr = parcelRequire("5YjMr");

var $hmeL1 = parcelRequire("hmeL1");
const $e24a006ad056402e$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $iSvIT.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $e24a006ad056402e$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $f6qj2.default)();
    const handleRecommendedChange = (0, $iSvIT.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $e24a006ad056402e$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $loA2J.jsx)((0, $85vSY.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($5YjMr.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $3ayMq.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jnh2H.PricingCards // must set the number of sections here if removing the bottom section
            ), {
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $hmeL1.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $e24a006ad056402e$var$disclaimerContainerCss = null;
const $e24a006ad056402e$var$disclaimerCss = null;
const $e24a006ad056402e$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $iSvIT.useState)(undefined);
    const providerResult = (0, $bU2dC.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rXz0.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bd3Mi.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $chlmU.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $e24a006ad056402e$export$2e2bcd8739ae039 = $e24a006ad056402e$var$UniformPricingCalculator;
function $e24a006ad056402e$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $f6qj2.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $3ItZP.serviceCollectionOfferingSkus).free,
            (0, $3ItZP.serviceCollectionOfferingSkus).standard,
            (0, $3ItZP.serviceCollectionOfferingSkus).premium,
            (0, $3ItZP.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($5YjMr.units.agentsUnitsLabel);
    return intl.formatMessage($5YjMr.units.usersUnitsLabel);
}

});
parcelRegister("3ayMq", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_KEY", function () { return $ae0d591ec5522d40$export$b65b36d21c9a62a9; });
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ae0d591ec5522d40$export$9c59efe722f16a54; });
const $ae0d591ec5522d40$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ae0d591ec5522d40$export$b65b36d21c9a62a9 = "confluence";
const $ae0d591ec5522d40$export$b24966420407028a = "strategyCollection";
const $ae0d591ec5522d40$export$46061d552ba374f4 = "teamworkCollection";
const $ae0d591ec5522d40$export$e7e2043098922532 = "compass";
const $ae0d591ec5522d40$export$6648fdba742bde2c = "serviceCollection";
const $ae0d591ec5522d40$export$b3fce742f95b2633 = "atlassianGuard";
const $ae0d591ec5522d40$export$9c59efe722f16a54 = {
    jira: $ae0d591ec5522d40$export$e36fc9e5c75fc113,
    confluence: $ae0d591ec5522d40$export$b65b36d21c9a62a9,
    strategy: $ae0d591ec5522d40$export$b24966420407028a,
    teamwork: $ae0d591ec5522d40$export$46061d552ba374f4,
    compass: $ae0d591ec5522d40$export$e7e2043098922532,
    service: $ae0d591ec5522d40$export$6648fdba742bde2c,
    guard: $ae0d591ec5522d40$export$b3fce742f95b2633
};

});

parcelRegister("jnh2H", function(module, exports) {

$parcel$export(module.exports, "PricingCards", function () { return $4ff5675958f7efd2$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $4ff5675958f7efd2$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $iSvIT.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $5ohHq.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $43MIc.default)(numSections),
            "--_1j6te2o": (0, $43MIc.default)(numberOfChildren),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $43MIc.default)(numSections === 1 ? `1px solid ${(0, $5ohHq.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $43MIc.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $43MIc.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $43MIc.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $iSvIT.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gEOac", function(module, exports) {

$parcel$export(module.exports, "useCalculationState", function () { return $7fc6bb143d8dc713$export$5ac48a71a65a15bc; });

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $7fc6bb143d8dc713$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $j1tjc.useSelector)($iXUxi.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCount(ctx)),
        unitTierLowerBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $j1tjc.useSelector)($iXUxi.getNumberFormatLocale)
    };
}

});
parcelRegister("j1tjc", function(module, exports) {

$parcel$export(module.exports, "useUnitCount", function () { return $58bc496f267c3520$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $58bc496f267c3520$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $58bc496f267c3520$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $58bc496f267c3520$export$97374d6e908d2c; });

var $iSvIT = parcelRequire("iSvIT");

var $kxn2n = parcelRequire("kxn2n");

var $bd3Mi = parcelRequire("bd3Mi");
function $58bc496f267c3520$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $58bc496f267c3520$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $58bc496f267c3520$export$f3fe2cc7a9497569() {
    return (0, $bd3Mi.usePricingCalculatorContext)().calculationResult;
}
const $58bc496f267c3520$export$2105062e25df4afe = (selector)=>{
    const context = (0, $bd3Mi.usePricingCalculatorContext)();
    return selector(context);
};
const $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $58bc496f267c3520$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $kxn2n.useCCPPriceFinderData)(offeringSkus, $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY, $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $iSvIT.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $58bc496f267c3520$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $58bc496f267c3520$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("bd3Mi", function(module, exports) {

$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $6a1ababb8109d222$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $6a1ababb8109d222$export$5a79cf764fd87278; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("8aCoe");
var $gz56C = parcelRequire("gz56C");
var $8XIVp = parcelRequire("8XIVp");
const $6a1ababb8109d222$var$PricingCalculatorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $6a1ababb8109d222$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $iSvIT.useContext)($6a1ababb8109d222$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $6a1ababb8109d222$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $iSvIT.useState)(props.inputValues);
    const calculate = (0, $iSvIT.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $gz56C.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $8XIVp.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $iSvIT.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $iSvIT.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = (0, $7Knp0._)({}, inputValues, changes);
        setInputValues(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($6a1ababb8109d222$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config
        },
        children: props.children
    });
};

});
parcelRegister("8aCoe", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("8XIVp")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("gz56C")).getProductCalculationInputs; });
parcelRequire("8XIVp");
parcelRequire("gz56C");

});
parcelRegister("8XIVp", function(module, exports) {

$parcel$export(module.exports, "calculateProductPricing", function () { return $050627253a5a34fa$export$6c0aa9d51dade71d; });

var $7Knp0 = parcelRequire("7Knp0");

var $3FlK9 = parcelRequire("3FlK9");
const $050627253a5a34fa$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $3FlK9.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $7Knp0._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("3FlK9", function(module, exports) {

$parcel$export(module.exports, "calculatePlanPricing", function () { return $2a81506982df3304$export$f9574505c9651410; });

var $7Knp0 = parcelRequire("7Knp0");

var $jl6Sn = parcelRequire("jl6Sn");

var $455M7 = parcelRequire("455M7");

var $c3Aax = parcelRequire("c3Aax");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $fNdr1 = parcelRequire("fNdr1");
const $2a81506982df3304$var$hamsPricingDataStub = {};
const $2a81506982df3304$var$hamsProductKeyStub = "";
function $2a81506982df3304$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $7Knp0._)({
        offeringSku: ccpOfferingSKU
    }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $fNdr1.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $jl6Sn.extractPricingTiersFromEntry)(ccpPricingData, $2a81506982df3304$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $2a81506982df3304$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $7Knp0._)({
                offeringSku: ccpOfferingSKU
            }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
        } else return (0, $7Knp0._)({
            offeringSku: ccpOfferingSKU
        }, (0, $455M7.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("jl6Sn", function(module, exports) {

$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $bd6c0a670fd8430c$export$99b3bd15b49bca3d; });

var $3jEwL = parcelRequire("3jEwL");
const $bd6c0a670fd8430c$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering === null || offering === void 0 ? void 0 : offering.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $3jEwL.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("3jEwL", function(module, exports) {

$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $4cd0225de8db8885$export$1fb00d50ed2ce89c; });

var $7mfju = parcelRequire("7mfju");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $4cd0225de8db8885$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $4cd0225de8db8885$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $7mfju.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $4cd0225de8db8885$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $4cd0225de8db8885$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $4cd0225de8db8885$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("455M7", function(module, exports) {

$parcel$export(module.exports, "calculatePrice", function () { return $c1c1f31d7fdb0d3b$export$8f857d3e1dbdf9cf; });

var $7mfju = parcelRequire("7mfju");

var $ax2GG = parcelRequire("ax2GG");

var $ikTVg = parcelRequire("ikTVg");

var $l9UIK = parcelRequire("l9UIK");
const $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $c1c1f31d7fdb0d3b$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        var _a_unitLimitLower, _b_unitLimitLower;
        return ((_a_unitLimitLower = a.unitLimitLower) !== null && _a_unitLimitLower !== void 0 ? _a_unitLimitLower : 0) - ((_b_unitLimitLower = b.unitLimitLower) !== null && _b_unitLimitLower !== void 0 ? _b_unitLimitLower : 0);
    });
    let matchingTierIdx = $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT ? (0, $l9UIK.default) : (0, $ikTVg.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $l9UIK.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = (finalTier === null || finalTier === void 0 ? void 0 : finalTier.unitLimitUpper) || 0;
        matchingTierIdx = $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $ikTVg.default);
    }
    const fmtUnit = (amount)=>(0, $ax2GG.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ax2GG.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $ikTVg.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $ikTVg.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ax2GG.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ax2GG.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("ax2GG", function(module, exports) {

$parcel$export(module.exports, "getFormattedPrice", function () { return $1e994aaafa291feb$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $1e994aaafa291feb$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $1e994aaafa291feb$export$4f6f7f43804883a5; });
const $1e994aaafa291feb$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $1e994aaafa291feb$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $1e994aaafa291feb$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $1e994aaafa291feb$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $1e994aaafa291feb$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$1e994aaafa291feb$var$fmtCurrencyValue(currencyISOCode, value, false);
const $1e994aaafa291feb$export$716b461c5fe22c57 = (currencyISOCode, value)=>$1e994aaafa291feb$var$fmtCurrencyValue(currencyISOCode, value, true);
const $1e994aaafa291feb$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("ikTVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0049fa8b0eecc5b3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $0049fa8b0eecc5b3$export$3a875854e1248ca4; });

var $86mMv = parcelRequire("86mMv");
function $0049fa8b0eecc5b3$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $86mMv.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $0049fa8b0eecc5b3$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("86mMv", function(module, exports) {

$parcel$export(module.exports, "getLocalUnitPrice", function () { return $bebbea878e2c5a98$export$e4a3f0ac75d6f09; });
const $bebbea878e2c5a98$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>{
    var _prices_find;
    return ((_prices_find = prices.find(({ currency: currency })=>currency === currencyISOCode)) === null || _prices_find === void 0 ? void 0 : _prices_find.unitPrice) || 0;
};

});


parcelRegister("l9UIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a29f0b36f17f8e$export$2e2bcd8739ae039; });

var $7mfju = parcelRequire("7mfju");

var $86mMv = parcelRequire("86mMv");
function $06a29f0b36f17f8e$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    var _tiers_;
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $86mMv.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $7mfju.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $7mfju.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: ((_tiers_ = tiers[0]) === null || _tiers_ === void 0 ? void 0 : _tiers_.pricingStrategy) === (0, $7mfju.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});


parcelRegister("c3Aax", function(module, exports) {

$parcel$export(module.exports, "getFreePriceCalc", function () { return $3c547c4b97809cab$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $3c547c4b97809cab$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $3c547c4b97809cab$export$2bd1dff4b72a4894; });

var $iSvIT = parcelRequire("iSvIT");

var $7mfju = parcelRequire("7mfju");

var $ax2GG = parcelRequire("ax2GG");

var $jl6Sn = parcelRequire("jl6Sn");

var $455M7 = parcelRequire("455M7");
const $3c547c4b97809cab$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ax2GG.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $3c547c4b97809cab$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $iSvIT.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $7mfju.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $7mfju.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $3c547c4b97809cab$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($3c547c4b97809cab$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $jl6Sn.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($3c547c4b97809cab$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $455M7.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});

parcelRegister("8EXPa", function(module, exports) {

$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $fdd1778c4e973722$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $fdd1778c4e973722$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $fdd1778c4e973722$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $fdd1778c4e973722$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $fdd1778c4e973722$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $fdd1778c4e973722$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $fdd1778c4e973722$export$f9cab01559b23739; });
const $fdd1778c4e973722$export$6e78cb64dcbedbb9 = "MONTHLY";
const $fdd1778c4e973722$export$36a5806a0e4fc360 = 5;
const $fdd1778c4e973722$export$2b15976b7672c2da = 201;
const $fdd1778c4e973722$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $fdd1778c4e973722$export$4d264dc26702f23b = 35000;
const $fdd1778c4e973722$export$9a2735659d85fd7c = Object.values($fdd1778c4e973722$export$eeb88db779daf862);
const $fdd1778c4e973722$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    }
];
const $fdd1778c4e973722$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("hqKpV", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("ktygn")).jiraOfferingSkus; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return (parcelRequire("1i1dJ")).CONFLUENCE_DEFAULT_UNIT_COUNT; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("1i1dJ")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("awylZ")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("fPLSq")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("1F9wN")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("5kiq4")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("iRy5O")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("5Rijz")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("3ItZP")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("fNdr1")).rovoDevOfferingSkus; });
parcelRequire("ktygn");
parcelRequire("1i1dJ");
parcelRequire("awylZ");
parcelRequire("fPLSq");
parcelRequire("1F9wN");
parcelRequire("fKYQO");
parcelRequire("5kiq4");
parcelRequire("iRy5O");
parcelRequire("5Rijz");
parcelRequire("3ItZP");
parcelRequire("fNdr1");

});
parcelRegister("ktygn", function(module, exports) {

$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $4898376357b002ff$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $4898376357b002ff$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $4898376357b002ff$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $4898376357b002ff$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $4898376357b002ff$export$3070b86c7bc28aea; });
const $4898376357b002ff$export$c34e5566df36b6ba = "MONTHLY";
const $4898376357b002ff$export$6521a918e64524fb = 300;
const $4898376357b002ff$export$9aef50cd5f48bb38 = 801;
const $4898376357b002ff$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $4898376357b002ff$export$b2b09200ca76754f = Object.values($4898376357b002ff$export$7529f2cfeec98447);
const $4898376357b002ff$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $4898376357b002ff$export$9aef50cd5f48bb38
    }
];
const $4898376357b002ff$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("1i1dJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $5b71775fc0eefb97$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $5b71775fc0eefb97$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $5b71775fc0eefb97$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $5b71775fc0eefb97$export$53fbba6eb29a73ad; });
const $5b71775fc0eefb97$export$d60dc2d142b5e9dd = "MONTHLY";
const $5b71775fc0eefb97$export$ab3750ec8101ffcc = 300;
const $5b71775fc0eefb97$export$f76a76b996ace375 = 801;
const $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $5b71775fc0eefb97$export$39e8fbae2abd0443 = Object.values($5b71775fc0eefb97$export$ffe6d3f38b5f7c3a);
const $5b71775fc0eefb97$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $5b71775fc0eefb97$export$f76a76b996ace375
    }
];
const $5b71775fc0eefb97$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("awylZ", function(module, exports) {

$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $e331a20e06ae1835$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $e331a20e06ae1835$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $e331a20e06ae1835$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $e331a20e06ae1835$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $e331a20e06ae1835$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $e331a20e06ae1835$export$2225b2a65811f064; });
const $e331a20e06ae1835$export$c00ddd271304729a = "ANNUAL";
const $e331a20e06ae1835$export$27579c7f06007c25 = 50;
const $e331a20e06ae1835$export$a99f1f06dfc3702a = 50;
const $e331a20e06ae1835$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $e331a20e06ae1835$export$3b4c7d53b38ef615 = Object.values($e331a20e06ae1835$export$8427e2db10f569be);
const $e331a20e06ae1835$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $e331a20e06ae1835$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $e331a20e06ae1835$export$a99f1f06dfc3702a
    }
];
const $e331a20e06ae1835$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("fPLSq", function(module, exports) {

$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $72cd788fce91eb06$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $72cd788fce91eb06$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $72cd788fce91eb06$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $72cd788fce91eb06$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $72cd788fce91eb06$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $72cd788fce91eb06$export$5861c5ce06e1556; });
const $72cd788fce91eb06$export$5784a04bb778d3c1 = "MONTHLY";
const $72cd788fce91eb06$export$482604a575f7b4a5 = 300;
const $72cd788fce91eb06$export$da0d6abd6eaa52b2 = 801;
const $72cd788fce91eb06$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $72cd788fce91eb06$export$b61ab2c6a18de6d4 = Object.values($72cd788fce91eb06$export$2e2107bfa20be1d8);
const $72cd788fce91eb06$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $72cd788fce91eb06$export$da0d6abd6eaa52b2
    }
];
const $72cd788fce91eb06$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("1F9wN", function(module, exports) {

$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $8db8255cb645bec1$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $8db8255cb645bec1$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $8db8255cb645bec1$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $8db8255cb645bec1$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $8db8255cb645bec1$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $8db8255cb645bec1$export$d2bfeac6f7899675; });
const $8db8255cb645bec1$export$501dc9dfd5b2bde4 = "MONTHLY";
const $8db8255cb645bec1$export$2aa1a93e0ac00fc = 100;
const $8db8255cb645bec1$export$2a2f7d7a7ae18850 = Infinity;
const $8db8255cb645bec1$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $8db8255cb645bec1$export$9f95f1c871571078 = Object.values($8db8255cb645bec1$export$a64578a63428ae96);
const $8db8255cb645bec1$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $8db8255cb645bec1$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fKYQO", function(module, exports) {
const $e2063f4ed18d2b98$export$be354061b07829a8 = "MONTHLY";
const $e2063f4ed18d2b98$export$2295858875312a6f = 75;
const $e2063f4ed18d2b98$export$66d53803b4a2565a = 201;
const $e2063f4ed18d2b98$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $e2063f4ed18d2b98$export$efd16829e921ffb8 = Object.values($e2063f4ed18d2b98$export$38631f866342776a);
const $e2063f4ed18d2b98$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $e2063f4ed18d2b98$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5kiq4", function(module, exports) {

$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $3ff405992fae1ce1$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $3ff405992fae1ce1$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $3ff405992fae1ce1$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $3ff405992fae1ce1$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $3ff405992fae1ce1$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $3ff405992fae1ce1$export$370b1f24abd91670; });
const $3ff405992fae1ce1$export$513f99bdcd3bd2 = "MONTHLY";
const $3ff405992fae1ce1$export$503245d941330408 = 10;
const $3ff405992fae1ce1$export$4ebabaf17c585254 = 201;
const $3ff405992fae1ce1$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $3ff405992fae1ce1$export$cf1798af40f51188 = Object.values($3ff405992fae1ce1$export$400db592c8d58797);
const $3ff405992fae1ce1$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $3ff405992fae1ce1$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("iRy5O", function(module, exports) {

$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $59446ee27ebc264e$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $59446ee27ebc264e$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $59446ee27ebc264e$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $59446ee27ebc264e$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $59446ee27ebc264e$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $59446ee27ebc264e$export$e0b3f0eba764d747; });
const $59446ee27ebc264e$export$2c789441f8bab310 = "MONTHLY";
const $59446ee27ebc264e$export$887bc0e84eafd3c = 300;
const $59446ee27ebc264e$export$862352663e0ac9d7 = Infinity;
const $59446ee27ebc264e$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $59446ee27ebc264e$export$74a0fd94f40ef5c5 = Object.values($59446ee27ebc264e$export$f93fb5caff8c778a);
const $59446ee27ebc264e$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $59446ee27ebc264e$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5Rijz", function(module, exports) {

$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $5cadcd121392db78$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $5cadcd121392db78$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $5cadcd121392db78$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $5cadcd121392db78$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $5cadcd121392db78$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $5cadcd121392db78$export$129a445945b6d9b3; });
const $5cadcd121392db78$export$9be98af08cc25cad = "MONTHLY";
const $5cadcd121392db78$export$d28097ea69640bd5 = 100;
const $5cadcd121392db78$export$13b500e201e8b319 = Infinity;
const $5cadcd121392db78$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $5cadcd121392db78$export$159558c2b3d66b11 = Object.values($5cadcd121392db78$export$91a420e9c7eb7c83);
const $5cadcd121392db78$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $5cadcd121392db78$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("3ItZP", function(module, exports) {

$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $98d786164d4b1720$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $98d786164d4b1720$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $98d786164d4b1720$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $98d786164d4b1720$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $98d786164d4b1720$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $98d786164d4b1720$export$7c96cfb0c18bfb05; });
const $98d786164d4b1720$export$9423de11a8a6dfa7 = "MONTHLY";
const $98d786164d4b1720$export$515fa2affea780b3 = 75;
const $98d786164d4b1720$export$3df704b75c4818f2 = 201;
const $98d786164d4b1720$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $98d786164d4b1720$export$953539e2774d6323 = Object.values($98d786164d4b1720$export$84b191ede7d628ea);
const $98d786164d4b1720$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $98d786164d4b1720$export$3df704b75c4818f2
    }
];
const $98d786164d4b1720$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fNdr1", function(module, exports) {

$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $9cae7a096cb356f4$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $9cae7a096cb356f4$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $9cae7a096cb356f4$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $9cae7a096cb356f4$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $9cae7a096cb356f4$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $9cae7a096cb356f4$export$120b0272a23f9b21; });
const $9cae7a096cb356f4$export$f7b45b42f23a06a6 = "MONTHLY";
const $9cae7a096cb356f4$export$c80f45e98f559c29 = 10;
const $9cae7a096cb356f4$export$5cdb7bb84622bb8e = Infinity;
const $9cae7a096cb356f4$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $9cae7a096cb356f4$export$69f1beff4f684452 = Object.values($9cae7a096cb356f4$export$6a8477cfea6a8fb8);
const $9cae7a096cb356f4$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $9cae7a096cb356f4$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $9cae7a096cb356f4$export$5cdb7bb84622bb8e
    }
];
const $9cae7a096cb356f4$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("gz56C", function(module, exports) {

$parcel$export(module.exports, "getProductCalculationInputs", function () { return $09379941b2c1216c$export$915d8a609f55f86e; });

var $7mfju = parcelRequire("7mfju");
const $09379941b2c1216c$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $7mfju.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("iXUxi", function(module, exports) {

$parcel$export(module.exports, "getUnitCount", function () { return $aa8ab4fefb73d271$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $aa8ab4fefb73d271$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $aa8ab4fefb73d271$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $aa8ab4fefb73d271$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $aa8ab4fefb73d271$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $aa8ab4fefb73d271$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $aa8ab4fefb73d271$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $aa8ab4fefb73d271$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $aa8ab4fefb73d271$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $aa8ab4fefb73d271$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $aa8ab4fefb73d271$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $aa8ab4fefb73d271$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $aa8ab4fefb73d271$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $aa8ab4fefb73d271$export$8808c13548cf959c; });
$parcel$export(module.exports, "getPricePlanId", function () { return $aa8ab4fefb73d271$export$235d4fbb478dfba0; });
const $aa8ab4fefb73d271$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $aa8ab4fefb73d271$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $aa8ab4fefb73d271$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $aa8ab4fefb73d271$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $aa8ab4fefb73d271$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $aa8ab4fefb73d271$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $aa8ab4fefb73d271$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $aa8ab4fefb73d271$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $aa8ab4fefb73d271$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $aa8ab4fefb73d271$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $aa8ab4fefb73d271$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedTotalPrice;
};
const $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.avgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $aa8ab4fefb73d271$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $aa8ab4fefb73d271$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $aa8ab4fefb73d271$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $aa8ab4fefb73d271$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $aa8ab4fefb73d271$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $aa8ab4fefb73d271$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $aa8ab4fefb73d271$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $aa8ab4fefb73d271$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $aa8ab4fefb73d271$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $aa8ab4fefb73d271$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $aa8ab4fefb73d271$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $aa8ab4fefb73d271$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $aa8ab4fefb73d271$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $aa8ab4fefb73d271$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $aa8ab4fefb73d271$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $aa8ab4fefb73d271$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $aa8ab4fefb73d271$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $aa8ab4fefb73d271$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $aa8ab4fefb73d271$export$2dd65b072d3a3106(price);
        return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $aa8ab4fefb73d271$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    // taken from `usePricingPlan` services/wac-web/src/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/use-pricing-plan.tsx
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("MciJy", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("85vSY")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("9IdXN")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("3A3AJ")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("3A3AJ")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryStandardPriceCard; });

$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("1rXz0")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("1JG1M")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("1wBc7")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("chlmU")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("fKqpx")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("fKqpx")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("4oRsq")).useLocalizedCtaUrl; });
$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return (parcelRequire("38spb")).useConfluenceDirectBuyExperiment; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return (parcelRequire("38spb")).ConfluenceDirectBuyButton; });
parcelRequire("85vSY");

var $1rXz0 = parcelRequire("1rXz0");

var $1JG1M = parcelRequire("1JG1M");

var $1wBc7 = parcelRequire("1wBc7");

var $chlmU = parcelRequire("chlmU");

var $fKqpx = parcelRequire("fKqpx");

var $4oRsq = parcelRequire("4oRsq");

var $38spb = parcelRequire("38spb");
parcelRequire("9IdXN");
parcelRequire("zcwoT");
parcelRequire("3A3AJ");
parcelRequire("ebQhK");

});
parcelRegister("85vSY", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $d80e3b774d43409a$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $7mfju = parcelRequire("7mfju");

var $11puL = parcelRequire("11puL");

var $E9GJt = parcelRequire("E9GJt");

var $5ohHq = parcelRequire("5ohHq");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
const $d80e3b774d43409a$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $j1tjc.useUnitCount)();
    const hasMonthlyBilling = (0, $j1tjc.useSelector)($iXUxi.hasMonthlyBilling);
    const hasAnnualBilling = (0, $j1tjc.useSelector)($iXUxi.hasAnnualBilling); // @ts-ignore
    const { isVariation: isDirectBuyExperimentVariation } = (0, $11puL.useDirectBuyCohort)(dataProductKey);
    const [visualUnitCount, setVisualUnitCount] = (0, $iSvIT.useState)(// @ts-ignore
    unitCount);
    (0, $iSvIT.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount(""); // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $esG4f.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $esG4f.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $E9GJt.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $loA2J.jsx)("legend", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $d80e3b774d43409a$var$labelStyles = null;
const $d80e3b774d43409a$var$legendStyles = null;
const $d80e3b774d43409a$var$inputTermStyle = null;
const $d80e3b774d43409a$var$inputCss = null;

});
parcelRegister("11puL", function(module, exports) {

$parcel$export(module.exports, "useDirectBuyCohort", function () { return $5810276580854fee$export$d49d57ae381ab55f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4LHd8 = parcelRequire("4LHd8");

var $9iWJ8 = parcelRequire("9iWJ8");
const $5810276580854fee$var$VALID_PRODUCT_KEYS = [
    "jiraSoftware",
    "jiraServiceDesk",
    "confluence"
];
function $5810276580854fee$export$d49d57ae381ab55f(productKey) {
    const isGateEnabled = (0, $4LHd8.default).checkGate("pricing_direct_buy_checkout_fg");
    const validProductKey = $5810276580854fee$var$VALID_PRODUCT_KEYS.includes(productKey);
    const experiment = (0, $9iWJ8.useExperiment)((0, $6iHNw._)((0, $7Knp0._)({}, (0, $9iWJ8.experiments).pricingDirectBuyCheckout), {
        options: {
            fireExperimentExposure: false,
            typeGuard: (0, $9iWJ8.experiments).pricingDirectBuyCheckout.options.typeGuard
        }
    }));
    if (!isGateEnabled || !validProductKey) return {
        isVariation: false
    };
    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isVariation = cohort === "variation";
    return {
        isVariation: isVariation
    };
}

});


parcelRegister("1rXz0", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $c4cc7b92cb3c529d$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $9gh2a = parcelRequire("9gh2a");
const $c4cc7b92cb3c529d$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {})
        })
    });

});

parcelRegister("1JG1M", function(module, exports) {

$parcel$export(module.exports, "PriceAltContainer", function () { return $6dfad2080b0e1df0$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
const $6dfad2080b0e1df0$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $6dfad2080b0e1df0$var$priceAltTextCss = null;

});

parcelRegister("1wBc7", function(module, exports) {

$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $866173e91f168028$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");
const $866173e91f168028$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1JG1M.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $esG4f.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($5YjMr.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($5YjMr.switchToAnnualToViewEnterprise)
        ]
    });
};
const $866173e91f168028$var$buttonCss = null;

});
parcelRegister("5YjMr", function(module, exports) {

$parcel$export(module.exports, "recommended", function () { return $b760b6823903a84f$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b760b6823903a84f$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b760b6823903a84f$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b760b6823903a84f$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b760b6823903a84f$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b760b6823903a84f$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b760b6823903a84f$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b760b6823903a84f$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b760b6823903a84f$export$68a1387c7d0a683f; });

var $6x1qA = parcelRequire("6x1qA");
const $b760b6823903a84f$export$bc5b8d0824876806 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b760b6823903a84f$export$fe0319385f0cf5a7 = (0, $6x1qA.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b760b6823903a84f$export$d8b49137e99effc2 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b760b6823903a84f$export$5eae4ab34e5b16ae = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b760b6823903a84f$export$bf2ba8467ff15aa5 = (0, $6x1qA.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b760b6823903a84f$export$2e64ce41e89d1e18 = (0, $6x1qA.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b760b6823903a84f$export$9e1a6bb525180618 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b760b6823903a84f$export$3277af2b318f7bfa = (0, $6x1qA.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b760b6823903a84f$export$68a1387c7d0a683f = (0, $6x1qA.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("chlmU", function(module, exports) {

$parcel$export(module.exports, "getFeaturesList", function () { return $4be00d6905ab8116$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7uQnK = parcelRequire("7uQnK");

var $cyfPT = parcelRequire("cyfPT");
const $4be00d6905ab8116$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7uQnK.RichTextComponent), {
                    text: (0, $cyfPT.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $4be00d6905ab8116$var$featureDetailsCss = null;

});

parcelRegister("fKqpx", function(module, exports) {

$parcel$export(module.exports, "UserTier", function () { return $3b63c85f893f58c4$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $3b63c85f893f58c4$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
const $3b63c85f893f58c4$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $3b63c85f893f58c4$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $f6qj2.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.tier),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $3b63c85f893f58c4$var$messages = (0, $6x1qA.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("4oRsq", function(module, exports) {

$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $0ce07cf2e2166107$export$b5e9728b9b8ebe33; });

var $3FBn4 = parcelRequire("3FBn4");
function $0ce07cf2e2166107$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $3FBn4.useLocalizedHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : "", {
        absolute: true
    });
}

});

parcelRegister("38spb", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return $de6bf2b1b8db6126$export$fae015b2716f6f7; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return $de6bf2b1b8db6126$export$ac5f3af0a99903ed; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $3ayMq = parcelRequire("3ayMq");

var $2lcYG = parcelRequire("2lcYG");

var $lrAJa = parcelRequire("lrAJa");
parcelRequire("hqKpV");
var $1i1dJ = parcelRequire("1i1dJ");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $de6bf2b1b8db6126$export$fae015b2716f6f7(props) {
    const { sku: sku } = props;
    const billingCycle = (0, $j1tjc.useSelector)((0, $iXUxi.getBillingCycle));
    return (0, $lrAJa.useDirectBuyExperiment)(billingCycle, sku, Object.values((0, $1i1dJ.confluenceOfferingSkus)).includes(// @ts-ignore
    sku));
}
const $de6bf2b1b8db6126$export$ac5f3af0a99903ed = (props)=>{
    const { sku: sku, edition: edition } = props;
    const pricingPlanId = (0, $j1tjc.useSelector)((ctx)=>(0, $iXUxi.getPricePlanId)(ctx, {
            offeringSku: sku,
            edition: edition
        }));
    const unitCount = (0, $j1tjc.useSelector)((0, $iXUxi.getUnitCount));
    let planName;
    if (edition === "standard") planName = "Standard";
    if (edition === "premium") planName = "Premium";
    if (!pricingPlanId || !planName) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lcYG.BuyNowButtonExperiment), {
        defaultUnitCount: (0, $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT),
        unitCount: unitCount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: (0, $3ayMq.CONFLUENCE_PRODUCT_KEY),
        planName: planName
    });
};

});
parcelRegister("2lcYG", function(module, exports) {

$parcel$export(module.exports, "BuyNowButtonExperiment", function () { return $b0f4bb9f957a36f1$export$dba4199f449a53bc; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $1UUq1 = parcelRequire("1UUq1");

var $5wOn9 = parcelRequire("5wOn9");

var $1QwzH = parcelRequire("1QwzH");
const $b0f4bb9f957a36f1$export$dba4199f449a53bc = (props)=>{
    const intl = (0, $f6qj2.default)();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const { defaultUnitCount: defaultUnitCount, unitCount: unitCount, pricingPlanId: pricingPlanId, dataProductKey: dataProductKey, planName: planName, edition: edition } = props;
    const bacDeepUrl = (0, $1QwzH.useBacDeepUrl)(userInfo.isUserLoggedIn, defaultUnitCount, unitCount, pricingPlanId);
    const buyButtonText = intl.formatMessage({
        id: "Pricing.PriceCard.BuyNow",
        defaultMessage: "Buy now"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
            intentType: "buy",
            containerId: "priceBlockBuyNow",
            productKey: dataProductKey,
            edition: edition,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: buyButtonText,
                className: "link-class",
                type: "anchor",
                anchorProps: {
                    target: "_self"
                },
                dataEventProps: {
                    "data-product-key": dataProductKey,
                    "data-event-component": "linkButton",
                    "data-event-container": "priceBlockBuyNow",
                    "data-event": "clicked",
                    "data-label": `${planName}-buy-now`,
                    "data-label-english": `${planName}-buy-now`
                },
                href: bacDeepUrl
            })
        })
    });
};

});
parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("1QwzH", function(module, exports) {

$parcel$export(module.exports, "useBacDeepUrl", function () { return $5ed43c02283f262a$export$c3b1e3c51f68d9a1; });

var $9xGVG = parcelRequire("9xGVG");
function $5ed43c02283f262a$export$c3b1e3c51f68d9a1(isLoggedIn, defaultUnitCount, unitCount, pricingPlanId) {
    return isLoggedIn ? $5ed43c02283f262a$var$getBacDeepUrl(defaultUnitCount, unitCount, pricingPlanId) : $5ed43c02283f262a$var$getBacDeepUrlForSignup(defaultUnitCount, unitCount, pricingPlanId);
}
const $5ed43c02283f262a$var$getBacDeepUrl = (defaultUnitCount, unitCount, pricingPlanId)=>{
    if (typeof window === "undefined") return "https://www.atlassian.com";
    const baseUrl = (0, $9xGVG.Environment).isProduction() ? "https://www.atlassian.com" : "https://wac.stg.internal.atlassian.com";
    const usersQueryParam = defaultUnitCount === unitCount ? "" : `&users=${unitCount}`;
    const queryParams = `place-order?pricingPlanId=${pricingPlanId}${usersQueryParam}`;
    return `${baseUrl}/purchase/cloudcart/${queryParams}`;
};
const $5ed43c02283f262a$var$getBacDeepUrlForSignup = (defaultUnitCount, unitCount, pricingPlanId)=>{
    if (typeof window === "undefined") return "https://id.atlassian.com";
    const continueBacUrl = $5ed43c02283f262a$var$getBacDeepUrl(defaultUnitCount, unitCount, pricingPlanId);
    const baseUrl = (0, $9xGVG.Environment).isProduction() ? "https://id.atlassian.com" : "https://id.stg.internal.atlassian.com";
    return `${baseUrl}/login?continue=${encodeURIComponent(continueBacUrl)}`;
};

});


parcelRegister("lrAJa", function(module, exports) {

$parcel$export(module.exports, "useDirectBuyExperiment", function () { return $834b03d0a4908f6e$export$fffd63fb7d65b164; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $4LHd8 = parcelRequire("4LHd8");

var $9iWJ8 = parcelRequire("9iWJ8");
const $834b03d0a4908f6e$var$VALID_SKU = [
    "confluence-standard",
    "confluence-premium"
];
const $834b03d0a4908f6e$var$VALID_SKU_EMPTY = [
    "confluence-free",
    "confluence-enterprise-sku"
];
function $834b03d0a4908f6e$export$fffd63fb7d65b164(billingCycle, offeringSku, shouldShowDirectBuy) {
    const isGateEnabled = (0, $4LHd8.default).checkGate("pricing_direct_buy_checkout_fg");
    const experiment = (0, $9iWJ8.useExperiment)((0, $6iHNw._)((0, $7Knp0._)({}, (0, $9iWJ8.experiments).pricingDirectBuyCheckout), {
        options: {
            fireExperimentExposure: false,
            typeGuard: (0, $9iWJ8.experiments).pricingDirectBuyCheckout.options.typeGuard
        }
    }));
    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isMonthly = billingCycle == "MONTHLY";
    const isVariation = cohort === "variation";
    const isValidEditionBtn = (0, $iSvIT.useMemo)(()=>offeringSku ? $834b03d0a4908f6e$var$VALID_SKU.includes(offeringSku) : false, [
        offeringSku
    ]);
    const isValidEditionEmpty = (0, $iSvIT.useMemo)(()=>offeringSku ? $834b03d0a4908f6e$var$VALID_SKU_EMPTY.includes(offeringSku) : false, [
        offeringSku
    ]);
    if (!offeringSku || !isMonthly || !isVariation || !isGateEnabled || !shouldShowDirectBuy) return {
        renderDirectBuyBtn: false,
        renderDirectBuyMatchSpace: false
    };
    return {
        renderDirectBuyBtn: isValidEditionBtn,
        renderDirectBuyMatchSpace: isValidEditionEmpty
    };
}

});


parcelRegister("9IdXN", function(module, exports) {

$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $0517d00c4a6a340c$export$f0e8bcb2fb60056a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $0517d00c4a6a340c$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("6OBwI", function(module, exports) {

$parcel$export(module.exports, "FreePriceCard", function () { return $bc086416dfe42289$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $bc086416dfe42289$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $bc086416dfe42289$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $bc086416dfe42289$export$ba2214b2dcd26743; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3lPlV = parcelRequire("3lPlV");

var $4gHL4 = parcelRequire("4gHL4");

var $jNkbn = parcelRequire("jNkbn");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $4oRsq = parcelRequire("4oRsq");
var $38spb = parcelRequire("38spb");
var $chlmU = parcelRequire("chlmU");
var $1JG1M = parcelRequire("1JG1M");
var $fKqpx = parcelRequire("fKqpx");
var $1wBc7 = parcelRequire("1wBc7");

var $j1tjc = parcelRequire("j1tjc");

var $5YjMr = parcelRequire("5YjMr");

var $iXUxi = parcelRequire("iXUxi");
function $bc086416dfe42289$var$usePriceCardTryIntent(props) {
    const { productKey: productKey, edition: edition } = props;
    return (0, $4gHL4.useTryIntent)({
        containerId: (0, $3lPlV.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
}
const $bc086416dfe42289$var$FREE_EDITION = "free";
const $bc086416dfe42289$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: $bc086416dfe42289$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$bc086416dfe42289$var$FREE_EDITION}-get-it-now`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: ctaUrl,
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$var$STANDARD_EDITION = "standard";
const $bc086416dfe42289$var$PREMIUM_EDITION = "premium";
const $bc086416dfe42289$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$STANDARD_EDITION
    }));
const $bc086416dfe42289$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $bc086416dfe42289$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const { renderDirectBuyBtn: renderDirectBuyBtn } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($5YjMr.perUserPerMonth) : intl.formatMessage($5YjMr.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        link: renderDirectBuyBtn && /*#__PURE__*/ (0, $loA2J.jsx)((0, $38spb.ConfluenceDirectBuyButton), {
            sku: fields.sku,
            edition: props.edition
        }),
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1wBc7.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($5YjMr.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("3lPlV", function(module, exports) {

$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $3e5191e452008b58$export$c5526af38120e3f; });
const $3e5191e452008b58$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("zcwoT", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $2c2a7242901762ae$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $2c2a7242901762ae$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $2c2a7242901762ae$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $2c2a7242901762ae$export$c277b80f2da61f89; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $2c2a7242901762ae$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$84affe19123eb209 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("3A3AJ", function(module, exports) {

$parcel$export(module.exports, "LoomFreePriceCard", function () { return $e968a4dcab76f69a$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $e968a4dcab76f69a$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $e968a4dcab76f69a$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $e968a4dcab76f69a$export$d88b84b01ca5e441; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $j1tjc = parcelRequire("j1tjc");

var $6OBwI = parcelRequire("6OBwI");
const $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $e968a4dcab76f69a$export$947796c8957ff6ff = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $e968a4dcab76f69a$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange
    }));
};
const $e968a4dcab76f69a$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    const intl = (0, $f6qj2.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $e968a4dcab76f69a$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
    }));
};
const $e968a4dcab76f69a$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount] = (0, $j1tjc.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("ebQhK", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $857985716a1569a3$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $857985716a1569a3$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $857985716a1569a3$export$1fb355a43910f211; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $857985716a1569a3$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $7Knp0._)({}, props));
};
const $857985716a1569a3$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $857985716a1569a3$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("bU2dC", function(module, exports) {

$parcel$export(module.exports, "useProviderProps", function () { return $e2230c4ac3c21599$export$521c373ccc32c300; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $9kpo9 = parcelRequire("9kpo9");

var $9Cnr8 = parcelRequire("9Cnr8");

var $8EXPa = parcelRequire("8EXPa");

var $iRy5O = parcelRequire("iRy5O");

var $1i1dJ = parcelRequire("1i1dJ");

var $5Rijz = parcelRequire("5Rijz");

var $ktygn = parcelRequire("ktygn");

var $5kiq4 = parcelRequire("5kiq4");

var $1F9wN = parcelRequire("1F9wN");

var $fNdr1 = parcelRequire("fNdr1");

var $3ItZP = parcelRequire("3ItZP");

var $awylZ = parcelRequire("awylZ");

var $fPLSq = parcelRequire("fPLSq");

var $j1tjc = parcelRequire("j1tjc");
function $e2230c4ac3c21599$export$521c373ccc32c300(props) {
    const { plans: plans, product: product } = props;
    const locale = (0, $9kpo9.useLocale)();
    const currencyISOCode = (0, $9Cnr8.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $6iHNw._)((0, $7Knp0._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $j1tjc.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $ktygn.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: $ktygn.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $ktygn.jiraPlanLimitConfigs,
                unitMinEnterprise: $ktygn.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1i1dJ.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1i1dJ.confluencePlanLimitConfigs,
                unitMinEnterprise: $1i1dJ.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fPLSq.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $fPLSq.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fPLSq.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5Rijz.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: $5Rijz.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5Rijz.guardPlanLimitConfigs,
                unitMinEnterprise: $5Rijz.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5Rijz.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $8EXPa.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: $8EXPa.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $8EXPa.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $8EXPa.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $8EXPa.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $awylZ.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $awylZ.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $awylZ.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $awylZ.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $awylZ.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $iRy5O.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: $iRy5O.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $iRy5O.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $iRy5O.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $iRy5O.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $3ItZP.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $3ItZP.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $3ItZP.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $3ItZP.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $3ItZP.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fNdr1.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: $fNdr1.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fNdr1.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $fNdr1.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fNdr1.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1F9wN.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: $1F9wN.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1F9wN.loomPlanLimitConfigs,
                unitMinEnterprise: $1F9wN.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $1F9wN.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5kiq4.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: $5kiq4.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5kiq4.jpdPlanLimitConfigs,
                unitMinEnterprise: $5kiq4.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5kiq4.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("9kpo9", function(module, exports) {
"use strict";
var $6ca9acf34c85a58f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ca9acf34c85a58f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ca9acf34c85a58f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6ca9acf34c85a58f$var$__exportStar((parcelRequire("lzarR")), module.exports);

});
parcelRegister("lzarR", function(module, exports) {
"use strict";
var $fb34f8afabff3c89$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb34f8afabff3c89$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb34f8afabff3c89$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fb34f8afabff3c89$var$__exportStar((parcelRequire("lrT2K")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("jJk5Z")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("iZOWt")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("3XOWT")), module.exports);

});
parcelRegister("lrT2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("jJk5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $e5d1ceda02205161$var$useLocale;

var $f6qj2 = parcelRequire("f6qj2");
function $e5d1ceda02205161$var$useLocale() {
    const intl = (0, $f6qj2.default)();
    return intl.locale;
}

});

parcelRegister("iZOWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $dd457090bbf63b1d$var$useLocalizedHref;

var $lrT2K = parcelRequire("lrT2K");

var $jJk5Z = parcelRequire("jJk5Z");
function $dd457090bbf63b1d$var$useLocalizedHref(href) {
    const locale = (0, $jJk5Z.useLocale)();
    if (locale === $lrT2K.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("3XOWT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $loA2J = parcelRequire("loA2J");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $loA2J.jsx)("br", {}),
    p: (chunks)=>(0, $loA2J.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $loA2J.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $loA2J.jsx)("span", {
            children: chunks
        })
});

});



parcelRegister("9Cnr8", function(module, exports) {

$parcel$export(module.exports, "COUNTRY_CODE_TO_CURRENCY", function () { return $ead8b56b1848df3d$export$5eecc1bf68a424bd; });
$parcel$export(module.exports, "getCurrencyFromUserLocale", function () { return $ead8b56b1848df3d$export$d308c60568c90469; });
$parcel$export(module.exports, "useGeoLocation", function () { return $ead8b56b1848df3d$export$f0ecc6cfe1a5d26a; });

var $iSvIT = parcelRequire("iSvIT");

var $56xle = parcelRequire("56xle");
const $ead8b56b1848df3d$export$7baaffefa21dec1 = "US";
const $ead8b56b1848df3d$export$496c65882823a55b = "bxp.currentLocale";
const $ead8b56b1848df3d$export$5eecc1bf68a424bd = {
    US: "USD",
    JP: "JPY",
    ja: "JPY"
};
const $ead8b56b1848df3d$export$d308c60568c90469 = (userLocale)=>{
    var _COUNTRY_CODE_TO_CURRENCY_userLocale;
    // @ts-ignore
    return (_COUNTRY_CODE_TO_CURRENCY_userLocale = $ead8b56b1848df3d$export$5eecc1bf68a424bd[userLocale]) !== null && _COUNTRY_CODE_TO_CURRENCY_userLocale !== void 0 ? _COUNTRY_CODE_TO_CURRENCY_userLocale : $ead8b56b1848df3d$export$5eecc1bf68a424bd[$ead8b56b1848df3d$export$7baaffefa21dec1];
};
async function $ead8b56b1848df3d$export$f5c42400285872e7(baseUrl, request) {
    if (typeof window === "undefined") {
        const headers = {};
        //@ts-ignore
        const awsRegion = globalThis.ssrContext.awsRegion;
        // S2S calls only work if the downstream service exists in the same region that our tesseract runtime is in
        const downStreamServiceExistsInSameTesseractRuntimeRegion = (0, $56xle.BxpExpressServiceSupportedRegions).has(awsRegion);
        if (!downStreamServiceExistsInSameTesseractRuntimeRegion) {
            console.log("Downstream service does not exist in the same region as current tesseract region. Current tesseract region: " + awsRegion);
            const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ""
            };
        }
        headers["x-ssr-service-name"] = "bxp-express";
        //@ts-ignore
        const environmentType = globalThis.ssrContext.environmentType;
        if (environmentType === "dev") {
            // bxp-express service does not have any dev instances so when we're in dev, point to staging
            headers["x-ssr-service-env"] = "staging";
            headers["x-ssr-service-region"] = "us-east-1"; // Bxp-express service in staging only lives in us-east-1 or us-west-2
        }
        //@ts-ignore
        headers["X-Forwarded-For"] = request === null || request === void 0 ? void 0 : request.headers["x-forwarded-for"];
        return await fetch(`/location`, {
            headers: headers
        }).then((response)=>{
            return response.json();
        }).then((json)=>{
            return {
                countryIsoCode: json.countryIsoCode || $ead8b56b1848df3d$export$7baaffefa21dec1,
                regionIsoCode: json.regionIsoCode || ""
            };
        }).catch(async ()=>{
            // If there's an error with s2s call - fall back to original fetchUserLocale
            const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ""
            };
        });
    } else {
        const fallbackLocale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
        return {
            countryIsoCode: fallbackLocale,
            regionIsoCode: ""
        };
    }
}
async function $ead8b56b1848df3d$export$b6ae37355b3e5433(baseUrl, request) {
    let localeFromStorage;
    if (typeof window !== "undefined") localeFromStorage = sessionStorage.getItem($ead8b56b1848df3d$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $ead8b56b1848df3d$export$f5c42400285872e7(baseUrl, request);
    return locationData.countryIsoCode;
}
async function $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl) {
    let localeFromStorage;
    if (typeof window !== "undefined") localeFromStorage = sessionStorage.getItem($ead8b56b1848df3d$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $ead8b56b1848df3d$export$284826310e51ae98(baseUrl);
    return locationData.countryIsoCode;
}
async function $ead8b56b1848df3d$export$284826310e51ae98(baseUrl) {
    return await fetch(`${baseUrl}/location`).then((response)=>{
        return response.json();
    }).then((json)=>{
        return {
            countryIsoCode: json.countryIsoCode || $ead8b56b1848df3d$export$7baaffefa21dec1,
            regionIsoCode: json.regionIsoCode || ""
        };
    }).catch(()=>{
        return {
            countryIsoCode: $ead8b56b1848df3d$export$7baaffefa21dec1,
            regionIsoCode: ""
        };
    });
}
function $ead8b56b1848df3d$export$f0ecc6cfe1a5d26a(baseUrl) {
    const [status, setStatus] = (0, $iSvIT.useState)("idle");
    const [countryCode, setCountryCode] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const locale = await $ead8b56b1848df3d$export$3fa76d5e19089da0(baseUrl);
            setStatus("complete");
            setCountryCode(locale);
        };
        fetchData();
    }, []);
    return {
        status: status,
        countryCode: countryCode
    };
}

});


parcelRegister("hmeL1", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorCard", function () { return $0a37e8017914ab10$export$14072311c149f96f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3ayMq = parcelRequire("3ayMq");
parcelRequire("MciJy");
var $9IdXN = parcelRequire("9IdXN");
var $zcwoT = parcelRequire("zcwoT");
var $3A3AJ = parcelRequire("3A3AJ");
var $ebQhK = parcelRequire("ebQhK");

var $cMtLi = parcelRequire("cMtLi");

var $6OBwI = parcelRequire("6OBwI");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $ktygn = parcelRequire("ktygn");
var $1i1dJ = parcelRequire("1i1dJ");
var $fPLSq = parcelRequire("fPLSq");
var $iRy5O = parcelRequire("iRy5O");
var $5Rijz = parcelRequire("5Rijz");
var $awylZ = parcelRequire("awylZ");
var $fNdr1 = parcelRequire("fNdr1");
var $3ItZP = parcelRequire("3ItZP");
var $1F9wN = parcelRequire("1F9wN");
var $5kiq4 = parcelRequire("5kiq4");
const $0a37e8017914ab10$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $3ayMq.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $ktygn.jiraOfferingSkus).free:
        case (0, $1i1dJ.confluenceOfferingSkus).free:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).free:
        case (0, $iRy5O.compassOfferingSkus).free:
        case (0, $8EXPa.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $ktygn.jiraOfferingSkus).standard:
        case (0, $1i1dJ.confluenceOfferingSkus).standard:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).standard:
        case (0, $5Rijz.guardOfferingSkus).standard:
        case (0, $iRy5O.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $ktygn.jiraOfferingSkus).premium:
        case (0, $1i1dJ.confluenceOfferingSkus).premium:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).premium:
        case (0, $5Rijz.guardOfferingSkus).premium:
        case (0, $iRy5O.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $ktygn.jiraOfferingSkus).enterprise:
        case (0, $1i1dJ.confluenceOfferingSkus).enterprise:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $7Knp0._)({}, props));
        case (0, $awylZ.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $fNdr1.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9IdXN.RovoDevStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPlusAiPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("cMtLi", function(module, exports) {

$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $e7bfa2be1f5e3998$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $e7bfa2be1f5e3998$export$3845e26e0454185b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $8EXPa = parcelRequire("8EXPa");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $e7bfa2be1f5e3998$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $e7bfa2be1f5e3998$export$3845e26e0454185b = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});





//# sourceMappingURL=pricing-calculator.f1da04ad.js.map
